<!-- restore-result.component.html -->
<div class="result-card"  *ngIf="result && Show">

 <div class="result-header">
    <span class="title">{{typeaction}} Result</span>
    <span class="badge-summary">
      {{ successItems.length }} of {{ result.length }} Applied
    </span>
  </div>

  <div #resultCard tabindex="-1" class="summary-bar">
    <span class="pill pill-success">
      <i class="dot dot-success"></i>
      {{ successItems.length }} Successful
    </span>
    <span class="pill pill-failed">
      <i class="dot dot-failed"></i>
      {{ failedItems.length }} Failed
    </span>
  </div>

<!-- Successful -->
<div class="section" *ngIf="successItems.length">
  <div class="section-label">Successful</div>
  <div class="records-grid">
    <div class="record-row" *ngFor="let item of successItems">
      <span class="status-icon success">✓</span>
      <div class="record-info">
        <div class="record-name">{{ item.name }}</div>
        <div class="record-id">{{ item.id }}</div>
      </div>
    </div>
  </div>
</div>

<!-- Failed -->
<div class="section" *ngIf="failedItems.length">
  <div class="section-label">Failed</div>
  <div class="records-grid">
    <div class="record-row" *ngFor="let item of failedItems">
      <span class="status-icon failed">✕</span>
      <div class="record-info">
        <div class="record-name">{{ item.name }}</div>
        <div class="record-id">{{ item.id }}</div>
        <div class="record-reason">{{ item.failure }}</div>
      </div>
    </div>
  </div>
</div>

</div>